import { type ReplacementApplication, type StrategyResult } from './types';

export const applyReplacementToText = (
  text: string,
  application: ReplacementApplication
): string => {
  const { start, end, replacement } = application;
  if (start < 0 || end > text.length || start > end) {
    return text;
  }
  return text.slice(0, start) + replacement + text.slice(end);
};

export const applyAllReplacementsOfStrategy = (
  text: string,
  applications: ReplacementApplication[]
): string => {
  const sorted = [...applications].sort((a, b) => b.start - a.start);
  return sorted.reduce((acc, app) => applyReplacementToText(acc, app), text);
};

export const findFirstActiveStrategy = (
  strategies: StrategyResult[]
): { strategy: StrategyResult; strategyIndex: number } | null => {
  for (let i = 0; i < strategies.length; i += 1) {
    const strategy = strategies[i];
    if (strategy && strategy.applications.length > 0) {
      return { strategy, strategyIndex: i };
    }
  }
  return null;
};
